import { Box, Grid } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { TextField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

export const RewardConfiguration = () => {
  return (
    <Box mt={2}>
      <Typography variant='subtitle1' gutterBottom>
        When They Spend
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <TextField
            name='pointSpend.pointCost'
            label='Points'
            fieldProps={{
              parse: parseNumber,
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
